export type AdminRole = "support" | "moderator" | "superadmin" | "analyst";

export interface AdminIdentity {
  id: string;
  email: string | undefined;
  role: AdminRole;
}

export type BffErrorDetails =
  | Array<{ field: string; issue: string }>
  | {
      items?: ReadonlyArray<{ key: string; ok: boolean; reason: string | null }>;
      usedBy?: number;
      affectedPicks?: number;
      reason?: string;
      retryAfter?: number;
      staleFacts?: ReadonlyArray<{
        fact: string;
        optionId: string | null;
        state: string;
        confirmedAt: string | null;
        urlChangePending: boolean;
      }>;
      maxBytes?: number;
    };

export type BffError = {
  code: string;
  message: string;
  details?: BffErrorDetails;
  traceId: string;
};

export type BffEnvelope<T> =
  | { data: T; error: null }
  | { data: null; error: BffError };

export const ROLE_HOME: Record<AdminRole, string> = {
  support: "/users",
  superadmin: "/users",
  analyst: "/dashboard",
  moderator: "/moderation",
};
